import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';
import { StyleRules } from '@material-ui/core/styles';

interface ComponentNameToClassKey extends Overrides {
  MuiDataGrid?: Partial<StyleRules>;
}

const MuiDataGrid: ComponentNameToClassKey['MuiDataGrid'] = {
  root: {
    '& .MuiDataGrid-columnsContainer': {
      backgroundColor: pallete.grey['200'],
      borderBottom: `3px solid ${pallete.primary.dark}`,
      fontWeight: 700,
    },
    '& .MuiDataGrid-viewport': {
      maxHeight: 'none !important',
      '& .MuiDataGrid-renderingZone': {
        maxHeight: 'none !important',
      },
    },
    '& .MuiDataGrid-row': {
      maxHeight: 'none !important',
      '& .MuiDataGrid-cell': {
        maxHeight: 'none !important',
      },
    },
  },
};

export default MuiDataGrid;
